import styled from '@themes/theme'

export const NickContent = styled.div`
  position: relative;
  .ant-form {
    display: flex;
    flex-wrap: wrap;
  }
  .ant-row.ant-form-item, .ant-row.ant-form-item.ant-form-item-with-help {
    width: calc(100% - 76px);
    margin-bottom: 56px;
  }
  .change-txt {
    width: 100%;
    display: block;
    margin-top: 18px;
    margin-bottom: 4px;
    color: ${props => props.theme.color.modalTxt};
    text-align: left;
  }
  .ant-form-item-control {
    padding: 0 13px;
    background: ${props => props.theme.color.themeTxt};
    border-radius: 18px;
  }
  // 새 닉네임 입력란
  .ant-input {
    padding-left: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    color: ${props => props.theme.color.modalgray};
    font-size: ${props => props.theme.font.medium};
    &:hover,
    &:active,
    &:focus {
      box-shadow: none !important;
    }
  }
  .nickname-check-btn {
    width: 66px;
    height: 34px;
    margin-left: 10px;
  }
`
